import { Fragment } from 'react';

import _ from 'lodash';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useSelector, useDispatch } from 'react-redux';

import CircularProgress from '@material-ui/core/CircularProgress';

import ImagesComponent from './ImagesComponent';
import classes from './ShortlistTable.module.css';

import dragHandle from '../../assets/img/dragIcon.svg';
import { CUSTOM_CLIENT_NAME } from '../../models/headers';
import useAddShortlistedoption from '../../store/contexts/useAddShortlistedoption';
import { calcCostPerSeat, getDistance, reorderShortListData } from '../../utils/utils';

const DetailsTable = ({ shortlist, currentDeal }) => {
  const latlng = useSelector((state) => state.comRed.latLong);
  const { putOption, inProgress } = useAddShortlistedoption();
  const dispatch = useDispatch();

  let shortListCopy = reorderShortListData(shortlist);

  const getLatLng = (address) => {
    const lng = address && address.lng;
    const lat = address && address.lat;

    return [lng, lat];
  };
  const dragendHandler = (params) => {
    if (!params.destination || params.destination.index === params.source.index) return;
    const srcI = params.source.index;
    const desI = params.destination.index;

    shortListCopy.splice(desI, 0, shortListCopy.splice(srcI, 1)[0]);

    shortListCopy = shortListCopy.map((obj, index) => ({
      ...obj,
      shortlistedOrder: index + 1,
    }));

    const ids = shortListCopy.map((item) => item.optionId);

    putOption(
      () => {
        dispatch({
          type: 'SET_SHORTLIST_IDS',
          ids: ids,
        });
      },
      'RESET',
      ids,
      shortListCopy,
    );
  };

  return (
    <Fragment>
      <thead>
        <tr>
          <th style={{ minWidth: '40px' }} rowSpan={2}></th>
          <th style={{ minWidth: '250px' }} rowSpan={2}>
            Photos
          </th>
          <th style={{ minWidth: '200px', whiteSpace: 'nowrap' }} rowSpan={2}>
            Name
          </th>
          <th rowSpan={2} style={{ borderRight: '1px solid rgba(0, 63, 45, 0.15)' }}>
            Office #
          </th>
          <th
            rowSpan={2}
            style={{
              borderRight: '1px solid rgba(0, 63, 45, 0.15)',
              textAlign: 'right',
            }}
          >
            Cost per Seat
          </th>
          <th
            colSpan={2}
            style={{
              textAlign: 'center',
              borderRight: '1px solid rgba(0, 63, 45, 0.15)',
              borderBottom: '1px solid rgba(0, 63, 45, 0.15)',
              padding: '5px',
              minWidth: '170px',
            }}
          >
            Availability
          </th>
          {latlng?.length > 0 && (
            <th rowSpan={2} style={{ textAlign: 'right' }}>
              Distance
            </th>
          )}
        </tr>
        <tr style={{ width: '100%', textAlign: 'center', whiteSpace: 'nowrap' }}>
          <th style={{ textAlign: 'right' }}>Desks</th>
          <th
            style={{
              textAlign: 'right',
              borderRight: '1px solid rgba(0, 63, 45, 0.15)',
            }}
          >
            Date
          </th>
        </tr>
      </thead>
      {typeof shortListCopy === 'undefined' && (
        <tbody>
          <tr>
            <td colSpan="10" style={{ textAlign: 'center' }}>
              Nothing is shortlisted
            </td>
          </tr>
        </tbody>
      )}

      {shortListCopy?.length > 0 && (
        <DragDropContext onDragEnd={dragendHandler}>
          <Droppable droppableId="droppale-1">
            {(provided, _) => (
              <tbody ref={provided.innerRef} {...provided.droppableProps}>
                {shortListCopy &&
                  shortListCopy.map((item, idx) => (
                    <Draggable key={item.id} draggableId={'draggable1-' + item.id} index={idx}>
                      {(provided, snapshot) => (
                        <tr
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          className={snapshot.isDragging ? classes.snapshot : ''}
                        >
                          <td
                            style={{ width: '40px', height: '130px' }}
                            {...provided.dragHandleProps}
                          >
                            <img src={dragHandle} alt=".." />
                          </td>
                          <td style={{ width: '250px', height: '130px' }}>
                            <ImagesComponent images={item.images} width="200px" height="110px" />
                          </td>

                          <td style={{ width: '150px', height: '130px' }}>{item.optionName}</td>

                          <td>
                            {' '}
                            {item.avails &&
                              item.avails.map((avail) => (
                                <div key={avail && avail.areaMeasurement}>
                                  Unit {avail && avail.unit} {avail && avail.officeType}, A{' '}
                                  {avail && avail.productType} with {avail && avail.capacity} desks
                                  {avail && avail.floor > 0 ? ', Floor #' + avail.floor : ''}
                                  {avail && avail.area ? ', Area ' + avail.area + ' ' : ''}
                                  {avail && avail.area && avail.areaMeasurement
                                    ? avail.areaMeasurement
                                    : ''}
                                </div>
                              ))}
                          </td>
                          <td style={{ textAlign: 'right', width: '120px' }}>
                            {calcCostPerSeat(item)[0] !== 0 && calcCostPerSeat(item)[0] !== 'NaN'
                              ? calcCostPerSeat(item)[0]
                              : '-'}
                          </td>
                          <td style={{ textAlign: 'right', width: '65px' }}>{item.capacity}</td>
                          <td style={{ textAlign: 'right' }}>{item.availDate}</td>
                          {latlng?.length > 0 && (
                            <td style={{ textAlign: 'right' }}>
                              {currentDeal?.['Client Name']?.[0].toLowerCase() ===
                              CUSTOM_CLIENT_NAME.toLocaleLowerCase()
                                ? getDistance(getLatLng(item.addressObj), latlng, 'km')
                                : getDistance(getLatLng(item.addressObj), latlng, 'miles')}
                            </td>
                          )}
                        </tr>
                      )}
                    </Draggable>
                  ))}
              </tbody>
            )}
          </Droppable>
        </DragDropContext>
      )}
      {inProgress && (
        <span className={classes.spinner}>
          <CircularProgress color="inherit" />
        </span>
      )}
    </Fragment>
  );
};

export default DetailsTable;
